import { FileRecord } from "../types";
import {
  getFileBlob,
  reprocessFile,
  deleteFile,
} from "../services/file-monitor-service";

export const handleDeleteFile = async (file: FileRecord): Promise<void> => {
  await deleteFile(file.id);
};

export const handleDownloadFile = async (file: FileRecord): Promise<void> => {
  // Fetch the file blob from the API
  const blobResponse = await getFileBlob(file.id);

  // Decode base64 string to binary
  const byteCharacters = atob(blobResponse.fileData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.codePointAt(i) ?? 0;
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create blob from binary data
  const blob = new Blob([byteArray], { type: "application/octet-stream" });

  // Create download link and trigger download
  const url = globalThis.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = blobResponse.fileName || file.fileName;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  link.remove();
  globalThis.URL.revokeObjectURL(url);
};

export const handleReprocessFile = async (file: FileRecord): Promise<void> => {
  await reprocessFile(file.id);
};
